import { render, staticRenderFns } from "./LanguageSelectorIndex.vue?vue&type=template&id=0470f9c9&"
import script from "./LanguageSelectorIndex.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectorIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports